

import {Component, Mixins, Prop, Ref} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import AdresForm from "@/components/forms/AdresForm.vue";
import Dates from "@/components/inputs/Dates.vue";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import IletisimTuruPicker from "@/components/pickers/IletisimTuruPicker.vue";
import UlkeTelefon from "@/components/inputs/UlkeTelefon.vue";
import TelefonNumarasi from "@/components/inputs/TelefonNumarasi.vue";
import {IletisimBilgisiTuruLabel} from "@/enum/IletisimBilgisiTuru";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";
import {BorcluVekiliEntity} from "@/entity/BorcluVekiliEntity";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import {ItemArrayManagerTableHeader} from "@/interface/TableHeader";
import IletisimForm from "@/components/forms/IletisimForm.vue";
import {MDB} from "@/plugins/uyap-plugin/MDB";
import {KisiSorgulaCevap} from "@/plugins/uyap-plugin/uyap/KisiSorgula";
import app from "@/main";
import {AvukatSorgulamaCevap} from "@/plugins/uyap-plugin/uyap/AvukatSorgulama";
import SehirPicker from "@/components/pickers/SehirPicker.vue";


@Component({
  components: {
    SehirPicker,
    IletisimForm,
    ItemArrayManager,
    TcKimlikNumarasi,
    AdresForm, FormWrapper, Dates,
    IletisimTuruPicker,
    UlkeTelefon,
    TelefonNumarasi,
  }
})
export default class BorcluVekiliForm extends Mixins(ObjectInputMixin) {
  localValue: any = new BorcluVekiliEntity();
  mdb = new MDB();
  sorguBilgiGerekli:boolean=false
  isTCKNRequired:boolean = false
  @Ref('formWrapper') formWrapper!: FormWrapper;
  @Prop({}) successOnValidate !: string | boolean;
  @Prop() borcluData!:any

  StatusCodeHelper = new StatusCodeHelper();
  cevap :AvukatSorgulamaCevap = {
    ad: "",
    soyad: "",
    avukatId: 0,
    tcKimlikNo: 0,
    isKamuAvukati: false,
    durum: 0
  };

  formData : any  = {
    tcKimlikNo:"",
    tbbNo:"",
    baroNo:"",
    ilKodu:""
  }
  headers: Array<ItemArrayManagerTableHeader> = [
    {
      value: "isim",
      text: "İletişim Bilgisi Türü",
      renderer: (row) => IletisimBilgisiTuruLabel[row.iletisim_tur_id],
    },
    {
      value: "",
      text: "İletisim Bilgisi",
      renderer: (row) => row.deger,
    }
  ];
  restrictInput(event:any) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'];
    const isNumeric = /^[0-9]$/;
    if (allowedKeys.includes(event.key)) return;
    if (!isNumeric.test(event.key)) {
      event.preventDefault();
    }
  }
  baroRules = [
    (value: any) => {
      return (!!value) || "Lütfen bu alanı doldurun."
    },
  ]
  baroSuccess(data:AvukatSorgulamaCevap){
    this.cevap = data
    this.localValue.ad = data.ad
    this.localValue.soyad = data.soyad
    this.localValue.tc_kimlik_no = data.tcKimlikNo
    this.input();
  }
  async uyapBaroSorgula(){
    try {
      let avukat =await app.$uyap.AvukatSorgulama().recursive(this.formData);
      this.baroSuccess(avukat);
      this.sorguBilgiGerekli=true
      this.$emit("success",avukat);
    }catch (e) {
      if(!this.localValue.il_id){
        app.$toast.error('İl Seçiniz!');

      }
    }
    this.input();
  }

  uyapTcSorgu(sorgu: KisiSorgulaCevap) {
    this.localValue.ad = sorgu.adi
    this.localValue.soyad = sorgu.soyadi
    this.sorguBilgiGerekli=true
    this.input();
  }

  get isSuccessOnValidate() {
    return this.successOnValidate || this.successOnValidate === "";
  }




  get isBaroNumarasiRequired(){
    if (!this.localValue.tc_kimlik_no)
      return true;
    else
      return false;
  }

  get adRule() {
    if (this.localValue.ad) {
      if (this.localValue.ad.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return 'Lütfen bu alanı doldurun.';
  }

  get soyadRule() {
    if (this.localValue.soyad) {
      if (this.localValue.soyad.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return 'Lütfen bu alanı doldurun.';
  }

  async adresUpdate(vekilId: number) {
    if (this.localValue.adres_id != null) {
      return await this.$http.put('/api/v1/adres/' + this.localValue.adres_id, this.localValue.adres).catch(error => this.StatusCodeHelper.error(error));
    } else if (this.localValue.adres) {
      return await this.$http.post('/api/v1/borclu-vekili/' + vekilId + '/adres', this.localValue.adres).catch(error => this.StatusCodeHelper.error(error));
    }
  }

  async save() {
    this.formWrapper.onFly = true;
    this.formData.baroNo=this.localValue.baro_numarasi
    this.formData.ilKodu=this.localValue.il_id


    if(this.formData.baroNo){
      this.isTCKNRequired =false
    }else{
      this.isTCKNRequired =true
    }
    if (this.localValue.id) {
      let response:any = await this.$http.put('/api/v1/borclu-vekili/' + this.localValue.id, this.localValue).catch(error => this.StatusCodeHelper.error(error)).finally(() => (this.formWrapper.onFly = false));
      let vekilId = response.data.id;
      await this.adresUpdate(vekilId);
      /* this.getIlAd(response.data.il_kodu)*/

      this.$emit("onSuccess");
    }else{
      this.localValue.borclu_id = this.$route.params.id;
      /*this.borcluData.vekiller.push(this.localValue)*/
      let response :any = await this.$http.post(
          `/api/v1/borclu-vekili/`, this.localValue).
      catch(error => this.StatusCodeHelper.error(error)).finally(() => (this.formWrapper.onFly = false));
      let vekilId = response.data.id;
      await this.adresUpdate(vekilId);
      this.$emit("onSuccess");
    }
  }

  /* getIlAd(ilCode:any) {
     const il  = this.mdb.iller.find(item => item.il === ilCode);
     this.localValue.il_kodu=il.il;
     return this.localValue.il_kodu ;
   }*/

  mounted(){
    /*this.getIlAd((this.localValue.il_kodu))*/
  }

  load() {
    this.$emit("load");
  }
}
